import React from 'react';
import { styled } from '@mui/material/styles';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { formatDate } from '../../helpers/utils';

const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: '350px',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.spacing(2),
  padding: theme.spacing(1),
  color: '#141417',
  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
  '&:hover': {
    transform: 'scale(1.03)',
    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
  },
}));

const CardHero = styled(CardContent)(({ theme }) => ({
  backgroundColor: 'rgb(22, 62, 106)',
  borderRadius: `${theme.spacing(2)} ${theme.spacing(2)}`,
  padding: theme.spacing(2),
  flexGrow: 1,
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  aspectRatio: '4 / 3', // Asegura relación visual 4:3
  backgroundColor: '#f5f5f5',
  borderRadius: theme.spacing(1),
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(1),
}));

const CardImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover', // Cubre todo sin deformar
  objectPosition: 'center',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'scale(1.05)',
  },
});

const CardTitle = styled(Typography)(({ theme }) => ({
  color: '#fff',
  fontSize: '1rem',
  fontWeight: 600,
  lineHeight: 1.2,
  margin: 0,
  [theme.breakpoints.up('sm')]: {
    fontSize: '1rem',
  },
}));

const CardDate = styled(Typography)(({ theme }) => ({
  color: '#fff',
  fontSize: '0.75rem',
  fontWeight: 400,
  marginTop: theme.spacing(1),
  opacity: 0.9,
}));

export default function PortalCommunicationCard({ data }) {
  return (
    <StyledCard tabIndex={0}>
      <CardHero>
        <ImageContainer>
          <CardImage
            src={data.imagenes?.[0] || '/placeholder.svg?height=200&width=300'}
            alt={data.titulo || 'Card image'}
          />
        </ImageContainer>
        <CardTitle variant="h2">{data.titulo || 'Sin título'}</CardTitle>
        {data.fechaPublicacion && (
          <CardDate>
            {formatDate(data.fechaPublicacion)}
          </CardDate>
        )}
      </CardHero>
    </StyledCard>
  );
}
